import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col } from 'react-bootstrap';
import VirtualizedSelect from 'react-virtualized-select';
import createFilterOptions from 'react-select-fast-filter-options';
import 'react-select/dist/react-select.css';

const InventoryOption = React.createClass({
  propTypes: {
    children: React.PropTypes.node,
    className: React.PropTypes.string,
    isDisabled: React.PropTypes.bool,
    isFocused: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    onFocus: React.PropTypes.func,
    onSelect: React.PropTypes.func,
    option: React.PropTypes.object.isRequired,
  },

  handleMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  },

  handleMouseEnter(event) {
    this.props.onFocus(this.props.option, event);
  },

  handleMouseMove(event) {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  },

  render() {
    const selectionStyle = {
      borderRadius: 3,
      display: 'inline-block',
      marginRight: 10,
      position: 'relative',
      top: -2,
      verticalAlign: 'middle',
      whiteSpace: 'pre',
      fontFamily: 'monospace',
      fontSize: 10,
    };

    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}
      >
        <span style={selectionStyle}>{this.props.option.label}</span>
      </div>
    );
  },
});

function VirtualizedInventoryOption ({ focusedOption, focusedOptionIndex, focusOption, key, labelKey, option, options, selectValue, style, valueArray }) {
  const selectionStyle = {
    borderRadius: 3,
    display: 'inline-block',
    marginRight: 10,
    position: 'relative',
    top: -2,
    verticalAlign: 'middle',
    whiteSpace: 'pre',
    fontFamily: 'monospace',
    fontSize: 10,
  };

  const classNames = [];
  if (option === focusedOption) {
    classNames.push('vOptionFocused');
  }

  return (
    <div
      className={classNames.join(' ')}
      style={style}
      key={key}
      onClick={() => selectValue(option)}
      onMouseOver={() => focusOption(option)}
      title={option.title}
    >
      <span style={selectionStyle}>{option.label}</span>
    </div>
  );
}

export class DetailedSelection extends Component {
  render() {
    const { input, options, defaultValue } = this.props;
    if (defaultValue) {
      return (
        <div>
          <Row>
            <Col sm={12}>
              {this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}
            </Col>
          </Row>
          <Select
            className="testSelect"
            optionComponent={InventoryOption}
            options={options}
            {...input}
            value={input.value.value || input.value || defaultValue.value}
            onBlur={() => { input.onBlur(input.value); }}
            ref="select"
            onInputKeyDown={this.props.onKeyPress}
          />
        </div>
      );
    }
    return (
      <div>
        <Row>
          <Col sm={12}>
            {this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}
          </Col>
        </Row>
        <Select
          className="testSelect"
          optionComponent={InventoryOption}
          options={options}
          {...input}
          value={input.value.value || input.value}
          onBlur={() => { input.onBlur(input.value); }}
          ref="select"
          onInputKeyDown={this.props.onKeyPress}
        />
      </div>
    );
  }
}

export class VirtualizedDetailedSelection extends Component {
  render() {
    const { input, options, defaultValue } = this.props;
    const filterOptions = createFilterOptions({ options });

    if (defaultValue) {
      return (
        <div>
          <Row><Col sm={12}>{this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}</Col></Row>
          <VirtualizedSelect
            className="testSelect"
            filterOptions={filterOptions}
            optionRenderer={VirtualizedInventoryOption}
            options={options}
            {...input}
            value={input.value.value || input.value || defaultValue.value}
            onBlur={() => { input.onBlur(input.value); }}
            onInputKeyDown={this.props.onKeyPress}
          />
        </div>
      );
    }
    return (
      <div>
        <Row><Col sm={12}>{this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}</Col></Row>
        <VirtualizedSelect
          className="testSelect"
          filterOptions={filterOptions}
          optionRenderer={VirtualizedInventoryOption}
          options={options}
          {...input}
          value={input.value.value || input.value}
          onBlur={() => { input.onBlur(input.value); }}
          onInputKeyDown={this.props.onKeyPress}
        />
      </div>
    );
  }
}


export default DetailedSelection;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/detailedSelection.jsx